/**
 * 获取url参数
 * @param {*} name
 * @param {*} url
 * @returns
 */
const getQueryString = (name, url = '') => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const target = url || window.location.search;
  const result = target.substr(1).match(reg);
  if (result !== null) {
    return result[2];
  }
  return 0;
};

export default getQueryString;
